'use client';
import React from 'react';
import Div from '@pezeshk-book/ui-kit/div';
import Text from '@pezeshk-book/ui-kit/text';
import Media from '@pezeshk-book/ui-kit/media';
import Image from '@elements/image';
import { ProfileImage } from '../../../../../../public/images/posts';
import { CommentInterface } from './comment.props';
import convertDate from '@utils/time/convert-date';
import Chip from '@pezeshk-book/ui-kit/chip';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';

const Comment = ({ user_name: userName, content, created_at: createdAt, isBuyer = false }: CommentInterface) => {
  const { lang } = useParams<{lang : 'fa'|'en'}>();
  const { modules: { comment } } = getDictionary(lang);
  return (
    <Div className={'w-full gap-4 md:gap-7'}>
      <Media greaterThan={'xs'}>
        <Div className={'relative w-12 h-12 sm:w-16 sm:h-16 md:w-28 md:h-28'}>
          <Image alt={userName} src={ProfileImage}/>
        </Div>
      </Media>
      <Div className={'w-full flex-col gap-2'}>
        <Div className={'justify-between'}>
          <Div className={'w-full justify-between items-center sm:items-start'}>
            <Div className={'items-center gap-2'}>
              <Media at={'xs'}>
                <Div className={'relative w-11 h-11 sm:w-14 sm:h-14 md:w-28 md:h-28'}>
                  <Image alt={userName} src={ProfileImage}/>
                </Div>
              </Media>
              <Div className={'gap-2 items-center'}>
                <Text typography={'xs'} type={'bold'}>{userName}</Text>
                {isBuyer ? (
                  <Chip variant={'reverse'} size={'tiny'} value={comment.buyer} />
                ) : null}
              </Div>
            </Div>
            <Div>
              <Text typography={'xs'}>{convertDate(createdAt, 'dddd، DD MMMM YYYY', lang)}</Text>
            </Div>
          </Div>
        </Div>
        <Text typography={'sm'} color={'grey.600'} align={'start'} className={'text-start'}>{content}</Text>
      </Div>
    </Div>
  );
};

export default Comment;
